import { useState, useEffect } from "react";
import { Nav, Image } from "react-bootstrap";
import { Link, useHref } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useClientUserState } from '../../Contexts/ClientUserStateContext';
import voyceLogo from '../../Images/logo.png';
import accessInterpreterGreyIcon from '../../Images/accessInterpreterGrey.png';
import accessInterpreterBlueIcon from '../../Images/accessInterpreterBlue.png';
import integrationsGreyIcon from '../../Images/integrationsGrey.png';
import integrationsBlueIcon from '../../Images/integrationsBlue.png'
import inviteGreyIcon from '../../Images/inviteGrey.png'
import inviteBlueIcon from '../../Images/inviteBlue.png'
import transactionGreyIcon from '../../Images/transactionGrey.png'
import transactionBlueIcon from '../../Images/transactionBlue.png'
import accountGreyIcon from '../../Images/accountGrey.png'
import accountBlueIcon from '../../Images/accountBlue.png'
import helpIcon from '../../Images/helpIcon.png'
import lougoutIcon from '../../Images/LogoutGray.png';
import "./Sidebar.css";

function Sidebar({ onItemSelected, onDefault }) {
  const [expanded, setExpanded] = useState(false);
  const [activeKey, setActiveKey] = useState(onDefault);
  const { clientUser } = useClientUserState();
  const { setVoyceToken } = useGlobalState();

  // TODO: Change later
  useEffect(() => {
    if (!activeKey) {
      setActiveKey("AccessInterpreter");
    } 
    if (activeKey === "AccountInformation" || activeKey === "AccountBilling") {
      setExpanded(true);
    }
    onItemSelected(activeKey);
  }, []);

  const navigate = useNavigate();
  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const handleSelect = (eventKey) => {
    if (eventKey === "AccountInformation" || eventKey === "AccountBilling") {
      setActiveKey(eventKey);
      onItemSelected(eventKey);
      setExpanded(true); 
    } else {
      setActiveKey(eventKey); 
      onItemSelected(eventKey);
      if (eventKey !== "AccountDetails") {
        setExpanded(false); 
      }
    }
  };


  const handleLogout = () => { 
    setVoyceToken(null);
    navigate('/Login');
  }

  const handleSupport = () => {
    window.open('https://web.voyceglobal.com/contact', '_blank');
  }

  return (
    <div className="sidebar">
      <div className="logo-wrapper">
        <div className="logo-container">
          <Image src={voyceLogo} alt="Voyce Logo" className="logo"/>
        </div>
      </div>
      <Nav className="pill-wrapper" variant="pills" activeKey={activeKey} onSelect={handleSelect}>
        <Nav.Link eventKey="AccessInterpreter">
          <div className="sidebar-pill">
            <img src={activeKey === "AccessInterpreter" ? accessInterpreterBlueIcon : accessInterpreterGreyIcon} alt="Icon" className="sidebar-icon" />
            Access Interpreter
          </div>
        </Nav.Link>
        <Nav.Link eventKey="Integrations">
          <div className="sidebar-pill">
            <img src={activeKey === "Integrations" ? integrationsBlueIcon : integrationsGreyIcon} alt="Icon" className="sidebar-icon" />
            Integrations
          </div>
        </Nav.Link>
        {
          clientUser.IsAdmin && (
            <Nav.Link eventKey="Invite">
              <div className="sidebar-pill">
                <img src={activeKey === "Invite" ? inviteBlueIcon : inviteGreyIcon} alt="Icon" className="sidebar-icon" />
                Invite Team Members
              </div>
            </Nav.Link>
          )
        }
        <Nav.Link eventKey="Transactions">
          <div className="sidebar-pill">
            <img src={activeKey === "Transactions" ? transactionBlueIcon : transactionGreyIcon} alt="Icon" className="sidebar-icon" />
            Transaction History 
          </div>
        </Nav.Link>
        
        <Nav.Link onClick={handleToggle} className={`align-items-center ${['AccountInformation', 'AccountBilling'].includes(activeKey) ? 'sub-active' : ''}`}>
          <div className="sidebar-pill">
            <img src={(activeKey === "AccountInformation" || activeKey === "AccountBilling") ? accountBlueIcon : accountGreyIcon} alt="Icon" className="sidebar-icon" />
            Account Details
            <span className={`arrow ${expanded ? 'up' : 'down'}`}></span>
          </div>
        </Nav.Link>
        <div className={`sub-items ${expanded ? 'expanded' : 'collapsed'}`}>
          <Nav.Link eventKey="AccountInformation" className="sub-item ">Account Information</Nav.Link>
          { clientUser.IsAdmin &&
          <Nav.Link eventKey="AccountBilling" className="sub-item ">Billing And Payments</Nav.Link>
          }
        </div>
       
        <div className="sidebar-bottom-container">
          <Nav.Link className="sidebar-bottom" onClick={handleSupport}>
            <div className="sidebar-pill">
              <img src={helpIcon} alt="?" className="help-icon" />
              Help Center
            </div>
          </Nav.Link>

          <Nav.Link className="sidebar-bottom">
            <div className="sidebar-pill" onClick={handleLogout}>
              <img src={lougoutIcon} alt="->" className="help-icon" />
              Logout
            </div>
          </Nav.Link>
        </div>
        
      </Nav>  
    </div>
  );
}

export default Sidebar;
